<script>
  import { _ } from "./i18n.js";
  import { Page, BlockTitle, Block, Button, Icon } from "framework7-svelte";
  import Toolbar from "./Toolbar.svelte";

  export let f7route;
  let orderId = f7route.params.id;
</script>

<style>
  img {
    width: 100%;
    margin-top: 20px;
  }
</style>

<Page>
  <BlockTitle medium>
    {$_('orderSuccess.title')}
    <span style="margin-left: 6px" class="icon icon-wink" />
  </BlockTitle>

  <Block>
    {@html $_('orderSuccess.placement', {
      values: {
        orderId: "<a href='/Order/" + orderId + "'>" + orderId + '</a>'
      }
    })}
    <div style="margin-top: 40px; margin-bottom: 40px;">
      <Button style="margin: 20px" fill round href="/Order/{orderId}">
        {$_('orderSuccess.showOrderDetails')}
        <Icon
          style="margin-left: 4px; vertical-align: text-top"
          icon="icon icon-order" />
      </Button>

      <Button color="green" style="margin: 20px" fill round href="/Order/My">
        Show My Orders
        <Icon
          style="margin-left: 4px; vertical-align: text-top"
          icon="icon icon-list" />
      </Button>
    </div>

    <img
      alt="Order Success"
      src="https://lh3.googleusercontent.com/bqy4Z-ChWBWTImQOtzI2KPPoAEtkJtiITZetgHYRNY1oQiaUzpR6Anu2pl5av68SEmhLAbbLvXhtdA6atQ92CRzO3TZsh1zRWXBUp0jwPA6KVKLPnkGb1B4qZn5TrHoYMXyLervw5avXC4YfWb9fADZy2mIa08dIAJiIoPYks-9MOTtWKO4vvEfIdXuNhaY-02DCPJH0EgqnSFsUg4s1qQfM1Pn8QnGaJ4ncX9Q1Kkw6KMu41pKCAcAfXOsx6hUuSCKPAur9EYbxwwkPUdE-Knqzgg6rlNWAIFepgyskewvaCLqa1evzPogs64K_l9azGlv8U1f88aH9DD-K63xDjH6ys6R9OvvAwnQTK7f9yTKzJC_6Amw9yQP7LS1Y6FEfqn_Ez5ZQ4lJS6xL4uxX5-3Ag72KDJP0l_KVoMB3j9ACI_VogwNz-IPx7_hkW1tnIeyINjqTIpVV0Bj9ontQJSReTOlkQEZ1uO8GdfyZApR3X9vKjDot48GQeSEVTaMKGoBCtTg1or-csBgxgUdPDO-MZMi5nAL_puxBcskkdO-MauzeJF3cYdO_iPIB_9ASVmrguplCKW3F2vpyuq8HivWUYgOGaRUZ5QNxsJzeDXRknVt01uI-HdYAyTes1NW28pV9xzFS8pXihE9SdHxbJOsZNXZYx99TZcoaGzoi3t49uFp91uzXM8qqggeYxT2OSqaPPpaOL3zI44_NdOAiPkWXaMphF7ujfK8wrjAgAgeFfdSa822KePA=s800" />
  </Block>

  <Toolbar tabLinkActive={'/Order/New'} />
</Page>
